export default __webpack_public_path__ + "static/media/Cang-Jei's Whisper.1c5277f1.jpg";